var React = require('react');

function Attachment (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 15.98C7.4 15.98 5.88999 15.36 4.75999 14.22L1.64 11.1L3.05 9.69L6.17 12.81C6.93 13.57 7.93 13.98 9 13.98C11.47 13.98 13 11.9 13 9.98C13 8.91 12.58 7.91 11.83 7.15L7.64999 2.97C7.27999 2.6 6.51 1.98 5.5 1.98C3.96 1.98 3 3.27 3 4.47C3 4.98 3.19999 5.7 3.64999 6.15L8.28999 10.68C8.67999 11.07 9.32999 11.07 9.70999 10.69C9.88999 10.51 9.99 10.27 10 10.02C10.01 9.74 9.90999 9.48 9.70999 9.28L6.59 6.16L8 4.75L11.12 7.87C11.71 8.46 12.03 9.27 12 10.1C11.97 10.86 11.66 11.58 11.12 12.12C9.99 13.25 8.00999 13.25 6.87999 12.12L2.23999 7.59C1.31999 6.67 1 5.39 1 4.49C1 2.33 2.72 0 5.5 0C6.78 0 8.04 0.56 9.06 1.58L13.24 5.76C14.37 6.89 15 8.4 15 10C15 12.87 12.71 15.98 9 15.98Z","fill":"#6E7C87"}));
}

Attachment.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Attachment;

Attachment.default = Attachment;
